// src/utils/regex.tsx
var cachedRegexes = /* @__PURE__ */ new Map();
function createCachedRegex(pattern) {
  const cached = cachedRegexes.get(pattern);
  if (cached) return cached;
  const regex = new RegExp(pattern);
  cachedRegexes.set(pattern, regex);
  return regex;
}
export {
  createCachedRegex
};
//# sourceMappingURL=regex.js.map